import React from 'react';

const NotFound:React.FC = () => {
  return (
    <div>
      <h1>404 - Page Not Found</h1>
      <p>The requested page could not be found.</p>
    </div>
  );
};

export default NotFound;
